import Vue from 'vue'
import Router from 'vue-router'
//import Home from './views/Home.vue'
const Cashpos = () => import('@/views/cashpos/form')
const ledger =() => import('@/views/ledger/form')
const grouphead =() => import('@/views/GroupHead/all')
const groupform =() => import('@/views/GroupHead/form')
const home = () => import('@/views/Home')
const product_category_form =() => import('@/views/Product_category/form')
const login =() => import('@/views/users/login')
const signup =() => import('@/views/users/signup')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: home
    },
    {
      path: '/cashpos',
      name: 'cashpos',
      component: Cashpos
    },
    {
      path: '/ledger/new',
      name: 'ledger',
      component: ledger
    },
    {
      path: '/grouphead',
      component: grouphead
    },
    {
      path: '/grouphead/form',
      component: groupform
    },
    {
      path: '/Product_category/new',
      component: product_category_form,
      props: { editmode: false}
    },
    {
      path: '/Product_category/:id/edit',
      component: product_category_form,
      props: { editmode: true}
    },
    {
      path: '/login',
      component: login
    },
    {
      path: '/signup',
      component: signup
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
    }
  ]
})
